export enum ContractType {
  FollowingReduction = 'Contrat suite à réduction / suspension',
  IodasRecovery = 'Reprise IODAS',
  SocioPro = 'Contrat socio-professionnel',
  StartingIERContract = "Contrat d'entrée IER",
  StudyContract = "Contrat étude ou reprise d'études",
  TrackingContract = 'Contrat de suivi',
}

export const RsaContractType: ContractType[] = [
  ContractType.FollowingReduction,
  ContractType.IodasRecovery,
  ContractType.StudyContract,
  ContractType.TrackingContract,
];

export const WorkflowedContractType: ContractType[] = [ContractType.SocioPro, ContractType.StartingIERContract];

export const labelsByAllContractType: string[] = [
  ContractType.FollowingReduction,
  ContractType.IodasRecovery,
  ContractType.SocioPro,
  ContractType.StartingIERContract,
  ContractType.StudyContract,
  ContractType.TrackingContract,
];

export const labelsByRsaTypedContractType: string[] = [
  ContractType.FollowingReduction,
  ContractType.IodasRecovery,
  ContractType.StudyContract,
  ContractType.TrackingContract,
];

export const labelsByWorkflowedTypedContractType: string[] = [ContractType.SocioPro, ContractType.StartingIERContract];
